import React, { Component } from "react";
import { Link } from "react-router";

import Logo from "../assets/logo.png";
import LogoArtist from "../assets/logo-artist.png";

export default class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="aboss__intro-products">
        <div className="aboss__intro-products-container">
          <div className="aboss__intro-products-artist">
            <img src={LogoArtist} alt="ABOSS Artist" />
            <h2>Artist</h2>
            <h1>For artist & team</h1>
            <p>
              Organize your data, streamline your backoffice and collaborate
              with your team
            </p>
            <Link to="products/artist">
              <button>Learn more about Artist</button>
            </Link>
          </div>
          <div className="aboss__intro-products-agency">
            <img src={Logo} alt="ABOSS Agency" />
            <h2>Agency</h2>
            <h1>For agents & managers</h1>
            <p>
              Manage multiple calendars, structure your backoffice and gain
              insight in data to optimize business strategies
            </p>
            <Link to="products/agency">
              <button>Learn more about Agency</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/introduction/components/products.js